export default "__VITE_ASSET__CjYTznKi__"